module.exports = __webpack_public_path__ + "img/BT_gallery_NO.e99eb237.svg";